import * as h2Api from '../h2Api'
import { CLUSTER_LISTING_LOADED } from '../actions/clusterProfile'

const initialState = {
  clusters: [],
  taxonomy: ''
}
const clusterListing = (state = initialState, action) => {
  switch (action.type) {
    case CLUSTER_LISTING_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          taxonomy: action.restCall.result.taxonomy,
          clusters: action.restCall.result.clusters
        }
      }

      return state

    default:
      return state
  }
}

export default clusterListing
